import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import { createModelCode } from '../model-code/ModelCode';
import { SimpleProject } from '../simple-project/SimpleProject';
import { createSimpleUser } from '../user/SimpleUser';

/**
 * # Partner
 *
 * Partner을 설명하세요.
 */
export const Partner = types
  .model('Partner')
  // --------------------------------------------------------------------------
  .props({
    partnerSid: types.optional(types.number, 0),
    company: types.optional(types.string, ''),
    partnerTypesCd: types.maybeNull(createModelCode()),
    gradeCd: types.maybeNull(createModelCode()),
    progressCd: types.maybeNull(createModelCode()),
    sales: types.maybeNull(types.optional(types.number, 0)),
    empCnt: types.maybeNull(types.optional(types.number, 0)),
    businessNum: types.maybeNull(types.optional(types.string, '')),
    telNo: types.maybeNull(types.optional(types.string, '')),
    faxNo: types.maybeNull(types.optional(types.string, '')),
    webSite: types.maybeNull(types.optional(types.string, '')),
    addr: types.maybeNull(types.optional(types.string, '')),
    addrDetail: types.maybeNull(types.optional(types.string, '')),
    compMemo: types.maybeNull(types.optional(types.string, '')),
    delYn: types.maybeNull(types.optional(types.boolean, false)),
    regDt: types.maybeNull(types.number),
    updDt: types.maybeNull(types.number),
    regUser: types.maybeNull(createSimpleUser()),
    updUser: types.maybeNull(createSimpleUser()),

    projects: types.maybeNull(types.array(SimpleProject)), // 관련 프로젝트
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model partner --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as IPartner;
      (Object.keys(newProps) as TPartnerKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TPartner = Instance<typeof Partner>;
type TPartnerSnapshot = SnapshotOut<typeof Partner>;

export interface IPartner extends TPartner {}
export type TPartnerKeys = keyof TPartnerSnapshot & string;
export interface IPartnerSnapshot extends TPartnerSnapshot {}
export const createPartner = () => types.optional(Partner, {} as TPartner);

export interface IPartnerFilter {
  text?: string;
  page?: number;
  size?: number;
  // company?: 'ap' | 'msp';
  partnerTypesCdList?: 'ap' | 'msp';
}

export type TPartnerFilter = IPartnerFilter;
